export default {
  "content": "<g clip-path=\"url(#a)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 0h8.5a.5.5 0 01.5.5V9H5V.5a.5.5 0 01.5-.5h1.92l2.23 2.6a.2.2 0 00.35-.13V0zM5.113 12.932A.89.89 0 015 12.49V11h14.07v1.49a.89.89 0 01-.44.77L15 15.41a2 2 0 00-1 1.74V22a2.001 2.001 0 01-2.35 2A2.08 2.08 0 0110 21.88v-4.76a2 2 0 00-1-1.7l-3.57-2.16a.89.89 0 01-.317-.328z\" fill=\"#3F4450\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 24 24"
  }
};